import { useState } from 'react';

import { DataGrid, GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { getCourseInstructorPoolOptions } from '@drivingdoc/api-client/generated/react-query';
import { Instructor } from 'types/instructors';

const columns: GridColDef<Instructor>[] = [
  {
    field: 'last_name',
    type: 'string',
    headerName: 'Last Name',
    minWidth: 150,
    valueGetter: (_value, row) => row.user?.last_name,
  },
  {
    field: 'first_time',
    type: 'string',
    headerName: 'First Name',
    minWidth: 150,
    valueGetter: (_value, row) => row.user?.first_name,
  },
];

export interface CourseInstructorListProps {
  courseId: string;
}

export function CourseInstructorList({ courseId }: CourseInstructorListProps) {
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    pageSize: 25,
    page: 0,
  });

  // get course sections
  const instructors = useQuery({
    ...getCourseInstructorPoolOptions({
      path: {
        id: courseId,
      },
      query: {
        page: paginationModel.page + 1,
        pageSize: paginationModel.pageSize,
      },
    }),
    // use previous data as placeholder to maintain a stable
    // reference while fetching the next page so the datagrid
    // doesn't reset the pagination model
    placeholderData: keepPreviousData,
    enabled: !!courseId,
  });

  const instructorData = instructors.data as { data: Instructor[]; total: number } | undefined;

  return (
    <DataGrid
      loading={instructors.isFetching}
      columns={columns}
      rows={instructorData?.data}
      getRowId={(row) => row.user_id}
      paginationMode="server"
      rowCount={instructorData?.total ?? 0}
      paginationModel={paginationModel}
      onPaginationModelChange={setPaginationModel}
      disableColumnFilter
      disableColumnSorting
    />
  );
}

export default CourseInstructorList;
